enum FilterQueryParams {
	LIMIT = 'cf_limit',
	OFFSET = 'cf_offset',
	SEARCH = 'cf_search',
	ASSIGNED_TO_ME = 'cf_assigned_to_me',
	ASSIGNED_GROUP = 'cf_assigned_group',
	CHAT_TAG_ID = 'cf_chat_tag_id',
	MESSAGES_SINCE_TIME = 'cf_messages_since_time',
	MESSAGES_BEFORE_TIME = 'cf_messages_before_time',
	UNREAD = 'cf_unread',
}

export default FilterQueryParams;
